import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'eventPublishDate'
})
export class EventPublishDatePipe implements PipeTransform {

  //公開期間内かつ実施期間外
  transform(list: any[]): any[] {
    return list.filter(item => item.reply_flg == "0");
  }
  
}


// WEBPACK FOOTER //
// ./src/app/pipes/event-publish-date.pipe.ts